// The product section is morphed on every AJAX product swap, so Okendo must re-init on the new markup.
document.addEventListener("product:ajax-rendered", (event) => {
  const api = window.okeWidgetApi;
  const section = event.detail?.section;
  if (!api?.initWidget || !section) return;

  section.querySelectorAll("[data-oke-star-rating]").forEach((element) => {
    api.initWidget(element, true);
  });
});

// Scrolled in JS, not via the #product-reviews hash: popstate would trigger an AJAX product re-render.
// Capture phase so Okendo's own click-to-scroll never also runs.
document.addEventListener(
  "click",
  (event) => {
    const link = event.target.closest("[data-product-reviews-link]");
    if (!link) return;

    event.preventDefault();
    event.stopPropagation();

    const target = document.getElementById("product-reviews");
    if (!target) return;

    const rootStyle = getComputedStyle(document.documentElement);
    const headerHeight = parseFloat(rootStyle.getPropertyValue("--header-height")) || 0;
    const promoBarHeight = parseFloat(rootStyle.getPropertyValue("--promo-bar-height")) || 0;

    window.scrollTo({
      top: Math.max(
        target.getBoundingClientRect().top + window.scrollY - headerHeight - promoBarHeight,
        0,
      ),
      behavior: "smooth",
    });
  },
  true,
);
